import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../project_config';
import { useAdminGate } from "../../utils/useAdminGate";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import Header from "../common/header/Header";
import DashboardHome from "./DashboardHome";
import DashboardSidebar from "./DashboardSidebar";

export default function Dashboard() {
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const { ready, isAdmin } = useAdminGate();
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'داشبورد مدیریت', href: '/dashboard/' },
	];

	useEffect(() => {
		Clarity.init(CLARITY_PROJECT_ID);
	}, []);

	useEffect(() => {
		const handleResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	if (!ready) {
		return null;
	}
	if (!isAdmin) {
		return <Navigate to="/login/" replace />;
	}

	return (
		<>
			<Helmet>
				<title>داشبورد مدیریت | همراهتیم</title>
				<meta name="description" content="داشبورد مدیریت همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'max-w-[1200px]' : ''} mx-auto px-4`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[35px]"></div>
					<main className={`${isDesktop ? 'max-w-[1200px] flex-row px-4' : 'p-[10px] flex-col'} w-full mx-auto flex gap-5`}>
						<DashboardSidebar isDesktop={isDesktop} />
						<DashboardHome />
					</main>
				</div>
				<div className="spacer p-[40px]"></div>
				<Footer isDesktop={isDesktop} />
			</div>
		</>
	);
}
